import { useEffect, Component } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import Lenis from "lenis";
import "@/index.css";

import Navbar from "./components/layout/Navbar.jsx";
import Footer from "./components/layout/Footer.jsx";
import WhatsAppButton from "./components/ui/WhatsAppButton.jsx";
import Home from "./pages/Home.jsx";
import OurClubs from "./pages/OurClubs.jsx";
import ClubKatargam from "./pages/ClubKatargam.jsx";
import ClubAdajan from "./pages/ClubAdajan.jsx";
import ClubVarachha from "./pages/ClubVarachha.jsx";
import FacilitiesPage from "./pages/Facilities.jsx";
import Blog from "./pages/Blog.jsx";
import BlogPost from "./pages/BlogPost.jsx";
import Community from "./pages/Community.jsx";
import About from "./pages/About.jsx";
import Events from "./pages/Events.jsx";
import Contact from "./pages/Contact.jsx";
import BlueMembership from "./pages/BlueMembership.jsx";
import Admin from "./pages/Admin.jsx";

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }
  static getDerivedStateFromError() {
    return { hasError: true };
  }
  render() {
    if (this.state.hasError) {
      return (
        <div className="flex min-h-screen flex-col items-center justify-center gap-4 bg-white px-6 text-center">
          <p className="font-display text-4xl text-navy">Something went wrong</p>
          <a href="/" className="rounded-full bg-brand px-8 py-3 text-xs font-bold uppercase tracking-[0.2em] text-white">
            Back to Home
          </a>
        </div>
      );
    }
    return this.props.children;
  }
}

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.__lenis?.scrollTo(0, { immediate: true });
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function LenisProvider({ children }) {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.1, wheelMultiplier: 1 });
    window.__lenis = lenis;
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);
  return children;
}

function FloatingHelpers() {
  const { pathname } = useLocation();
  if (pathname.startsWith("/admin")) return null;
  return (
    <>
      <WhatsAppButton />
    </>
  );
}

function App() {
  return (
    <ErrorBoundary>
      <LenisProvider>
        <BrowserRouter>
          <ScrollToTop />
          <Navbar />
          <main>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/our-clubs" element={<OurClubs />} />
              <Route path="/clubs/katargam" element={<ClubKatargam />} />
              <Route path="/clubs/adajan" element={<ClubAdajan />} />
              <Route path="/clubs/varachha" element={<ClubVarachha />} />
              <Route path="/facilities" element={<FacilitiesPage />} />
              <Route path="/blue-membership" element={<BlueMembership />} />
              <Route path="/community" element={<Community />} />
              <Route path="/blog" element={<Blog />} />
              <Route path="/blog/:slug" element={<BlogPost />} />
              <Route path="/about" element={<About />} />
              <Route path="/events" element={<Events />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/admin" element={<Admin />} />
              <Route path="*" element={<Home />} />
            </Routes>
          </main>
          <Footer />
          <FloatingHelpers />
          <Toaster position="bottom-center" richColors toastOptions={{ style: { fontFamily: "'Plus Jakarta Sans', sans-serif" } }} />
        </BrowserRouter>
      </LenisProvider>
    </ErrorBoundary>
  );
}

export default App;
